/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetCustomer200Response,
  GetCustomerPromotions200Response,
} from '../models/index';
import {
    GetCustomer200ResponseFromJSON,
    GetCustomer200ResponseToJSON,
    GetCustomerPromotions200ResponseFromJSON,
    GetCustomerPromotions200ResponseToJSON,
} from '../models/index';

export interface GetCustomerRequest {
    phoneNumber: string;
}

export interface GetCustomerPromotionsRequest {
    customerId: string;
}

/**
 * 
 */
export class CustomersApi extends runtime.BaseAPI {

    /**
     */
    async getCustomerRaw(requestParameters: GetCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCustomer200Response>> {
        if (requestParameters['phoneNumber'] == null) {
            throw new runtime.RequiredError(
                'phoneNumber',
                'Required parameter "phoneNumber" was null or undefined when calling getCustomer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['phoneNumber'] != null) {
            queryParameters['phoneNumber'] = requestParameters['phoneNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/customers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomer200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCustomer(requestParameters: GetCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCustomer200Response> {
        const response = await this.getCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCustomerPromotionsRaw(requestParameters: GetCustomerPromotionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCustomerPromotions200Response>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getCustomerPromotions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/customers/{customerId}/promotions`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomerPromotions200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCustomerPromotions(requestParameters: GetCustomerPromotionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCustomerPromotions200Response> {
        const response = await this.getCustomerPromotionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
